import * as React from 'react';

const FiltersIcon = () => (
  <svg
    width="52"
    height="40"
    viewBox="0 0 52 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="4" width="48" height="36" rx="1" fill="white" />
    <rect
      x="0.5"
      y="4.5"
      width="47"
      height="35"
      rx="0.5"
      stroke="#0E1323"
      strokeOpacity="0.08"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 19H15C14.4 19 14 18.6 14 18C14 17.4 14.4 17 15 17H17H17.2C17.6 15.8 18.7 15 20 15C21.3 15 22.4 15.8 22.8 17H23H33C33.6 17 34 17.4 34 18C34 18.6 33.6 19 33 19H23H22.8C22.4 20.2 21.3 21 20 21C18.7 21 17.6 20.2 17.2 19H17ZM21 18C21 17.4 20.6 17 20 17C19.4 17 19 17.4 19 18C19 18.6 19.4 19 20 19C20.6 19 21 18.6 21 18ZM31 25H33C33.6 25 34 25.4 34 26C34 26.6 33.6 27 33 27H31H30.8C30.4 28.2 29.3 29 28 29C26.7 29 25.6 28.2 25.2 27H25H15C14.4 27 14 26.6 14 26C14 25.4 14.4 25 15 25H25H25.2C25.6 23.8 26.7 23 28 23C29.3 23 30.4 23.8 30.8 25H31ZM27 26C27 26.6 27.4 27 28 27C28.6 27 29 26.6 29 26C29 25.4 28.6 25 28 25C27.4 25 27 25.4 27 26Z"
      fill="#0E1323"
      fillOpacity="0.5"
    />
    <circle
      cx="46"
      cy="6"
      r="5"
      fill="#E01268"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);
export default FiltersIcon;
